
// ********* Import CSS *************** //

import '@styles/main.scss';
import "./contact.css";

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup *************** //

import '../nav-header-footer/email-contact-new-classes.js';

// **************************** Loading Spinner ****************************** //

window.addEventListener('load', () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.display = "block";
    setTimeout(() => {
      preloader.style.transition = "opacity 0.2s ease";
      preloader.style.opacity = 0;
      setTimeout(() => preloader.remove(), 200);
    }, 1000);
  }
});

// **************** JS for Cube Rotation & Contact Buttons ******************** //

const cube = document.getElementById("cube");

const emailBtn = document.querySelector('#email-btn');
const followBtn = document.querySelector('#follow-btn');
const funBtn = document.getElementById("fun-btn");

const contactNav = document.querySelector('nav[aria-label="Contact options selector"]');

let hasTyped = false;


const clickOnSide = (side) => {

  if (!cube) return;
  const activeSide = cube.dataset.side;
  
  cube.classList.replace(`show-${activeSide}`, `show-${side}`);
  cube.setAttribute("data-side", side);

  /* =======================================================================
     Typewriter Text & Copy Text Badge
  ========================================================================== */

  const typewriterParagraph = document.querySelector(".typewriter-text p");

  const copyBadge = document.getElementById("copy-badge");
  
  if (typewriterParagraph && copyBadge) {

    if (side === "right") {

      const textString = typewriterParagraph.textContent || "info@girlscodesavannah.org";
      
      // Calculate the exact physical pixel length of the string using a temporary element
      const measurementCanvas = document.createElement("span");
      measurementCanvas.style.fontFamily = "'Oswald', sans-serif";
      measurementCanvas.style.fontSize = window.getComputedStyle(typewriterParagraph).fontSize || "26px";
      measurementCanvas.style.fontWeight = "700";
      measurementCanvas.style.letterSpacing = "0.5px";
      measurementCanvas.style.position = "absolute";
      measurementCanvas.style.visibility = "hidden";
      measurementCanvas.style.whiteSpace = "nowrap";
      measurementCanvas.textContent = textString;
      
      document.body.appendChild(measurementCanvas);
      const computedPixelWidth = measurementCanvas.getBoundingClientRect().width;
      document.body.removeChild(measurementCanvas);
      
      // Pass the precise pixel constraint back to your CSS rendering engine
      typewriterParagraph.style.setProperty('--final-width', `${computedPixelWidth}px`);

      if (!hasTyped) {
        // FIRST TAP: Wait 1050ms for the 3D cube spin, then trigger unified animation timeline
        setTimeout(() => {
          typewriterParagraph.classList.add("start-typing");
          hasTyped = true; 

          // TIMELINE EVENT: Automatically slide the copy utility icon open the exact millisecond 
          // the unified typing-and-blink keyframe track completes its run.
          typewriterParagraph.addEventListener("animationend", (e) => {
            if (e.animationName === "typing-and-blink") {
              copyBadge.classList.add("slide-open");
            }
          }, { once: true }); // Automatically detaches after initial completion loop
          
        }, 1050);
      } else {
        // SUBSEQUENT TAPS: Force text open instantly and slide the badge open without delay
        typewriterParagraph.classList.add("already-typed");
        copyBadge.classList.add("slide-open");
      }
    }
  }
};

/* ==========================================================================
   CLIPBOARD UTILITY CONTROLLER (Icon-Only Execution Framework)
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const copyBadge = document.getElementById("copy-badge");

  const emailText = document.querySelector(".typewriter-text p");

  if (copyBadge && emailText) {

    copyBadge.addEventListener("click", () => {

      const emailString = emailText.textContent;
      
      navigator.clipboard.writeText(emailString).then(() => {

        copyBadge.classList.add("copied");

        copyBadge.innerHTML = `<i class="bi bi-check-lg"></i>`;
        
        setTimeout(() => {
          copyBadge.classList.remove("copied");
          copyBadge.innerHTML = `<i class="bi bi-clipboard"></i>`;
        }, 2000);
      }).catch(err => {
        console.error("Clipboard failure trace: ", err);
      });
    });
  }
});


/* ==========================================================================
   Show correct side of cube on button click
   ========================================================================== */

if (contactNav) {
  contactNav.querySelectorAll(".btn").forEach(btn => {
    btn.addEventListener("click", (e) => {
      // Use currentTarget to ensure the side parameter is captured cleanly 
      const targetSide = e.currentTarget.dataset.side;
      if (targetSide) {
        clickOnSide(targetSide);
      }
    });
  });
}
